export default __webpack_public_path__ + "static/media/Volantes.249da2e3.png";